import React, { useState } from 'react'

import { InputCheckbox } from '../input/input'
import { ButtonLink } from '../button/button'
import { Title4 } from '../title/title'
import styles from './filterMobile.module.css'

const FilterMobile = (props) => {
  const {
    title,
    filter,
    selected,
    disabled,
    disabledMessage,
    onChange,
    onApply,
    onCancel,
  } = props

  const [optionsSelected, setOptionsSelected] = useState(selected || [])

  const isSelected = (option) => {
    const optionFind = optionsSelected.find(
      (optionSelected) => optionSelected.value === option.value,
    )

    if (!optionFind) return false
    return true
  }

  const handleApply = () => {
    if (onApply) onApply(filter.type, optionsSelected)
    if (onCancel) onCancel()
  }

  const getOptionByValue = (value, options) => {
    return options.find((option) => option.value === value)
  }

  const handleChange = (selected, id) => {
    if (selected) {
      const newOptionsSelected = [...optionsSelected]
      const optionSelected = getOptionByValue(id, filter.options)

      if (optionSelected) {
        newOptionsSelected.push(optionSelected)
        setOptionsSelected(newOptionsSelected)
        if (onChange) onChange(filter.type, newOptionsSelected)
      }
    } else {
      const updatedOptionsSelected = optionsSelected.filter(
        (optionSelected) => optionSelected.value !== id,
      )
      setOptionsSelected(updatedOptionsSelected)
      if (onChange) onChange(filter.type, updatedOptionsSelected)
    }
  }

  return (
    <div className={styles.filterMobile}>
      <header className={styles.header}>
        <Title4>{title}</Title4>
        <p className={`${styles.advice} ${disabled ? styles.show : null}`}>
          {disabled && disabledMessage}
        </p>
      </header>
      <section className={styles.checkboxes}>
        {filter.options.map((option) => (
          <InputCheckbox
            key={option.value}
            id={option.value}
            name={option.value}
            label={option.label}
            value={option.value}
            selected={isSelected(option)}
            onChange={handleChange}
          />
        ))}
      </section>
      <footer className={styles.footer}>
        <ButtonLink label={'cancelar'} onClick={onCancel} />
        <ButtonLink
          label={'aplicar'}
          type="primary"
          onClick={handleApply}
          disabled={disabled}
        />
      </footer>
    </div>
  )
}

export default FilterMobile
